import { createFileRoute } from "@tanstack/react-router";
import { LocalLandingPage } from "@/components/landing/LocalLandingPage";
import { madridLandings } from "@/data/madrid-landings";
import { buildLocalLandingHead } from "@/lib/local-landing-seo";

const data = madridLandings["agencia-geo-madrid"]!;

export const Route = createFileRoute("/agencia-geo-madrid")({
  head: () => buildLocalLandingHead(data),
  component: () => <LocalLandingPage data={data} />,
});
